import React from "react";
import Pagination from "react-js-pagination";
import { Col, Row,Input } from "reactstrap";

const PaginationComponent = props => {

    const { page, total_count, limit, changePage, changeFilter } = props;


    return (
            <Row className="mb-1">
                <Col lg={4} md={4}>

                    <Row className="p-2">
                    <Col lg={6} md={3} >
                        <label>No of Records</label>
                    {/* </Col>    
                    <Col lg={4} md={4}> */}
                        <Input
                            type="select"
                            name="limit"
                            onChange={e => {
                                e.target.value = parseInt(e.target.value, 10);
                                changeFilter(e);
                            }}
                            value={limit}
                            >
                            {/* <option value={5}>5</option> */}
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                        </Input>
                            </Col>
                    </Row>
                   
                </Col>
                <Col lg={4} md={4}>
                    <div>
                        <p className="mb-sm-0 mt-2 text-center" >
                            Page <span className="font-weight-bold">{page + 1}</span>{" "} Of <span className="font-weight-bold">{Math.ceil(total_count / limit)}</span>
                        </p>
                    </div>
                </Col>
                <Col lg={4} md={12} sm={12} xs={12} >
                    <Pagination
                        //firstPageText='FirstPage'
                        // hideFirstLastPages={true}
                        innerClass="pagination pagination-rounded"
                        prevPageText="<"
                        nextPageText=">"
                        itemClass="page-item"
                        linkClass="page-link"
                        activePage={page + 1}
                        itemsCountPerPage={limit}
                        totalItemsCount={total_count}
                        pageRangeDisplayed={4}
                        //lastPageText='LastPage'
                        onChange={e => {
                            if((page + 1) !== e)
                                changePage(e - 1);
                        }}
                    />  

                </Col>
            </Row>
          
    )
}

export default PaginationComponent;